import {
  formatDateTimeWithSeconds,
  parseLocationDto,
  toYardLocationString,
  YardPositionDto,
} from '@tom-ui/utils'
import { ContainerUpdateDifferenceDto, ContainerUpdateDto } from 'modules/integration/src/app/api'
import {
  EventDifferenceModel,
  HistoryEventConfig,
  historyEventConfigList,
  HistoryLookupModel,
} from './container-history-details.model'

const handleDateField = (value: string | null | undefined) => {
  if (!value || value === 'null') return value

  const newValue = value.replace(/^"(.*)"$/, '$1')
  return formatDateTimeWithSeconds(newValue)
}

//TODO: contact integration team, they should send actual event type name
export const cleanEventName = (eventType: string) => {
  return eventType.replace('Dto', '').trim()
}

export const handleContainerHistoryEvent = (
  containerUpdateDto: ContainerUpdateDto,
  lookupSource?: HistoryLookupModel,
) => {
  if (!containerUpdateDto.Differences) return []

  const eventConfig =
    historyEventConfigList.find(
      config => config.eventType === cleanEventName(containerUpdateDto.Event?.EventType ?? ''),
    ) || ({} as HistoryEventConfig)

  const differences: EventDifferenceModel[] = []

  const locationField = eventConfig.locationField
  if (locationField) {
    const locations = containerUpdateDto.Differences.filter(diff =>
      diff.Path?.startsWith(locationField),
    )

    if (locations.length !== 0) {
      const previousValues = locations
        .map(loc => parseLocationDto(loc.PreviousValue))
        .filter(val => val !== undefined)
        .map(val => val as YardPositionDto)

      const newValues = locations
        .map(loc => parseLocationDto(loc.NewValue))
        .filter(val => val !== undefined)
        .map(val => val as YardPositionDto)

      differences.push({
        title: locationField,
        previousValue: toYardLocationString(previousValues),
        newValue: toYardLocationString(newValues),
      })
    }
  }

  return containerUpdateDto.Differences.reduce(
    (differences: EventDifferenceModel[], currentDifference: ContainerUpdateDifferenceDto) => {
      if (eventConfig.hiddenFields?.includes(currentDifference.Path ?? '')) return differences

      if (locationField && currentDifference.Path?.startsWith(locationField ?? ''))
        return differences

      const useOnlyNewValue = eventConfig.showOnlyNewFields?.includes(currentDifference.Path ?? '')
      const dateFormatField = eventConfig.dateFormatFields?.includes(currentDifference.Path ?? '')

      const format = (val: string | null | undefined) => {
        if (val === null || val === 'null') return null

        val = val?.replace(/^"(.*)"$/, '$1') //remove quotes if any

        // first check the dateFormat
        if (dateFormatField) {
          return handleDateField(val)
        }

        //then the lookup
        if (eventConfig.lookupConfig && lookupSource) {
          const lookup = eventConfig.lookupConfig.find(
            lu => lu.fieldPath === currentDifference.Path,
          )
          if (lookup && val) {
            return lookupSource[lookup.sourceName]?.[val] ?? 'null'
          }
        }

        return val
      }

      const title = currentDifference.Path?.replace(/^\./, '')
      const previousValue = useOnlyNewValue ? null : format(currentDifference.PreviousValue)
      const newValue = format(currentDifference.NewValue)

      if (previousValue === null && (newValue === null || newValue === '')) return differences

      differences.push({
        title: title,
        previousValue: previousValue,
        newValue: newValue,
      })

      return differences
    },
    differences,
  )
}
